import { createSelector } from 'reselect'
import { isUndefined, find } from 'lodash-es'

import { intToBool } from '../../utils'

export const canAddSpeaker = (speakers, maxNumOfSpeakers) => {
  if (isUndefined(speakers) || isUndefined(maxNumOfSpeakers)) {
    return false
  }

  return speakers.length < maxNumOfSpeakers
}

export default ({ getFeatureRoot }) => {
  const getSpeakers = (state) => getFeatureRoot(state).speakers
  const getMaxNumOfSpeakers = (state) => getFeatureRoot(state).maxNumOfSpeakers
  const getCrudSpeakerId = (state) => getFeatureRoot(state).crudSpeakerId

  const getIsAllowedAddingSpeaker = createSelector(
    [getSpeakers, getMaxNumOfSpeakers],
    canAddSpeaker
  )

  const getIsCrudSpeakerInviteSent = createSelector(
    [getSpeakers, getCrudSpeakerId],
    (speakers, crudSpeakerId) => {
      const speaker = find(speakers, (s) => s.live_speaker_id === crudSpeakerId)
      return speaker ? intToBool(speaker.sent_invitation_p) : false
    }
  )

  return {
    getIsAllowedAddingSpeaker,
    getIsCrudSpeakerInviteSent,
  }
}
